(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    /*
    Zest "Send To Multiple Addresses" button.
    S&S 09/28/26: the button lives inside the cart drawer, which the theme re-renders
    (innerHTML swap) every time the cart changes. The old code grabbed #zestBTN once at
    page load and bound a click listener to that element, so the button went dead after
    any add-to-cart / quantity change, and threw on pages that loaded with an empty cart.
    Now: one delegated listener on document + a re-check whenever the drawer re-renders.
  */
  (function () {
    if (window.__zestMultiShipBound) return;
    window.__zestMultiShipBound = true;

    function checkEligibility(button) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          if (button) {
            button.disabled = false;
            button.title = '';
          }

          var hasGiftCards = cart.items.some(function (item) {
            return item.gift_card || /\b(?:gift[ _-]?card)\b/i.test(item.product_type);
          });

          var hasSubscriptions = cart.items.some(function (item) {
            return item.selling_plan_allocation;
          });

          var errorTarget = hasGiftCards && hasSubscriptions
            ? 'gift cards and subscriptions'
            : hasGiftCards ? 'gift cards'
            : hasSubscriptions ? 'subscriptions'
            : null;

          if (errorTarget) {
            if (button) {
              button.disabled = true;
              button.title = "We're sorry — " + errorTarget + " aren't eligible for this feature.";
            }
            return null;
          }

          return cart.token;
        })
        .catch(function (error) {
          console.error('Zest multi-ship: error fetching cart:', error);
          return null;
        });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('#zestBTN');
      if (!button) return;
      event.preventDefault();

      checkEligibility(button).then(function (token) {
        if (token) {
          window.location.href = 'https://' + Shopify.shop + '/apps/zest/start-multi-ship/' + token;
        }
      });
    });

    function refreshButtonState() {
      var button = document.getElementById('zestBTN');
      if (button) checkEligibility(button);
    }

    function init() {
      refreshButtonState();

      var drawer = document.getElementById('cart-drawer');
      if (drawer && window.MutationObserver) {
        var timer;
        new MutationObserver(function () {
          clearTimeout(timer);
          timer = setTimeout(refreshButtonState, 150);
        }).observe(drawer, { childList: true, subtree: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-cart-upsell"] && !Shopify.designMode) return;
  try {
    /*
    S&S cart drawer add-on offer. The drawer re-renders its HTML on every cart change, so this uses
    one delegated listener on document (bound once) instead of binding to the button itself.
  */
  (function () {
    if (window.__ssUpsellBound) return;
    window.__ssUpsellBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-ss-upsell-add]');
      if (!button || button.disabled) return;
      event.preventDefault();

      var label = button.querySelector('[data-ss-upsell-label]');
      var original = label ? label.innerHTML : '';
      button.disabled = true;
      if (label) label.textContent = 'Adding…';

      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(button.dataset.variantId),
            quantity: 1,
            properties: { _upsell: 'cart-drawer' }
          }]
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed: ' + response.status);
          return response.json();
        })
        .then(function () {
          if (window.location.pathname.replace(/\/$/, '').slice(-5) === '/cart') {
            window.location.reload();
            return;
          }
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        })
        .catch(function (error) {
          console.error('S&S upsell:', error);
          button.disabled = false;
          if (label) label.innerHTML = 'Sorry, that didn’t work — tap to try again';
          setTimeout(function () { if (label) label.innerHTML = original; }, 3000);
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
